// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 20px 60px; /* Added top padding equal to navbar height */
  text-align: center;
  background-color: #8ECCF5;
  font-family: 'Inter', sans-serif;
  min-height: 100vh;
  width: 100%;
  box-sizing: border-box;
}

.home-title {
  font-size: 3rem;
  margin-bottom: 20px;
  color: #E0EF80; /* Updated color */
  font-family: 'Inter', sans-serif;
  font-weight: 300; /* Make the text skinnier */
}

.home-description {
  font-size: 1.2rem;
  max-width: 800px;
  margin-bottom: 40px;
  color: #333333;
  font-family: 'Inter', sans-serif;
}

.feature-section {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
}

.feature {
  background-color: #ffffff;
  padding: 20px;
  border-radius: 8px;
  width: 250px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  font-family: 'Inter', sans-serif;
}

.feature h3 {
  color: #0047AB;
  margin-bottom: 10px;
  font-family: 'Inter', sans-serif;
}

.feature p {
  color: #555555;
  font-size: 1rem;
  font-family: 'Inter', sans-serif;
}

.get-started-button {
  padding: 12px 24px;
  font-size: 1.1rem;
  background-color: white;
  color: black;
  border: none;
  border-radius: 9999px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
  margin-bottom: 40px;
}

.get-started-button:hover {
  background-color: #00A67E;
  transform: translateY(-2px);
}

.get-started-button:active {
  transform: translateY(0);
}`, "",{"version":3,"sources":["webpack://./src/components/Home.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB,EAAE,6CAA6C;EACtE,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;EAChC,iBAAiB;EACjB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc,EAAE,kBAAkB;EAClC,gCAAgC;EAChC,gBAAgB,EAAE,2BAA2B;AAC/C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,2DAA2D;EAC3D,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":[".home-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 60px 20px 60px; /* Added top padding equal to navbar height */\n  text-align: center;\n  background-color: #8ECCF5;\n  font-family: 'Inter', sans-serif;\n  min-height: 100vh;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.home-title {\n  font-size: 3rem;\n  margin-bottom: 20px;\n  color: #E0EF80; /* Updated color */\n  font-family: 'Inter', sans-serif;\n  font-weight: 300; /* Make the text skinnier */\n}\n\n.home-description {\n  font-size: 1.2rem;\n  max-width: 800px;\n  margin-bottom: 40px;\n  color: #333333;\n  font-family: 'Inter', sans-serif;\n}\n\n.feature-section {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  justify-content: center;\n}\n\n.feature {\n  background-color: #ffffff;\n  padding: 20px;\n  border-radius: 8px;\n  width: 250px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  font-family: 'Inter', sans-serif;\n}\n\n.feature h3 {\n  color: #0047AB;\n  margin-bottom: 10px;\n  font-family: 'Inter', sans-serif;\n}\n\n.feature p {\n  color: #555555;\n  font-size: 1rem;\n  font-family: 'Inter', sans-serif;\n}\n\n.get-started-button {\n  padding: 12px 24px;\n  font-size: 1.1rem;\n  background-color: white;\n  color: black;\n  border: none;\n  border-radius: 9999px;\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.2s ease;\n  margin-bottom: 40px;\n}\n\n.get-started-button:hover {\n  background-color: #00A67E;\n  transform: translateY(-2px);\n}\n\n.get-started-button:active {\n  transform: translateY(0);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
